import { SerializedStyles } from "@emotion/react";
import { Container } from "@snapchat/snap-design-system";
import { FC, ReactNode } from "react";
import { Flexbox } from "../Flexbox";
import { _containerStyle, messageStyle, titleContainerStyle, titleStyle } from "./Alert.styles";

interface AlertProps {
    title: ReactNode;
    icon?: ReactNode;
    message: ReactNode;
    containerStyle?: SerializedStyles;
}

export const Alert: FC<AlertProps> = ({ title, icon, containerStyle, message }) => {
    return (
        <Container css={[_containerStyle, containerStyle]}>
            <Flexbox css={titleContainerStyle} alignItems="center">
                {icon}
                <div css={titleStyle}>{title}</div>
            </Flexbox>
            <div css={messageStyle}>{message}</div>
        </Container>
    );
};
